import { type SelectionMode, type SelectionRange } from '../../../machine/state/types';

/**
 * Determines if the current selection and mode is for a single cell.
 * Used to opt out of drawing highlights and calculating geometry of a box.
 */
export function isSingleCellSelection(range: SelectionRange, mode: SelectionMode) {
  if (mode !== 'cell') {
    return false;
  }

  return (
    range.anchor.col.index === range.lead.col.index &&
    range.anchor.row.index === range.lead.row.index
  );
}
